<!--新建医案库-->
<template>
    <div class="dialog">
        <el-dialog
            title='新建医案库'
            :visible.sync="show"
            width="600px"
            :before-close="handleClose">
            <el-form
                :model="newForm"
                class="auditFormStyle"
                >
                <el-form-item
                    label="医案库名称:"
                    :label-width="formLabelWidth"
                    prop="storeName"
                >
                <el-input
                    class="audit-reason"
                    show-word-limit
                    v-model="newForm.storeName"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="描述:"
                    :label-width="formLabelWidth"
                    prop="storeDesc"
                >
                    <el-input
                    type="textarea"
                    class="audit-reason"
                    :rows="4"
                    v-model="newForm.storeDesc"
                    ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleClose" class="medical-btn">取 消</el-button>
                <el-button type="primary" @click="sure_new" class="medical-btn">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
    props: ['show'],
    data () {
        return {
            formLabelWidth:'100px',
            
        }
    },
    computed: {
      ...mapState(['newForm'])
    },
    methods: {
        ...mapActions(['getSelfStore_list']),
        handleClose(){
            this.$emit('update:show',false);
        },
        sure_new(){
            if(this.newForm.storeName==''){
                this.$message.error('请输入医案库名称');
                return
            }
            let params = this.newForm;
            //请求
            delete params.id;
            this.$http.post(`/wdyak/addStore`, params).then(res=>{
                if (res.data && res.data.code == 0) {
                    this.$message({
                        message: res.data.msg,
                        type: "success",
                    });
                    this.handleClose();
                    this.getSelfStore_list();
                    // this.setNewForm(newForm);
                    // this.$emit('searchList',1)
                }else{
                    this.$message.error(res.data.msg||'请求失败～');
                }
            })
        }
    }
}
</script>

<style lang='less' scoped>
.dialog /deep/ input,.dialog /deep/ textarea{
    border: none !important;
}
.dialog /deep/ .auditFormStyle{
    width: 550px;
}
.dialog /deep/.el-dialog__header{
    line-height: 24px;
    background-color:  #409EFF;
    font-size: 18px;
    padding: 10px 20px;
}
.dialog /deep/ .el-dialog__title{
    color: #fff;
}
    
.dialog /deep/ .el-dialog__header{
    line-height: 24px;
    background-color:  #409EFF;
    font-size: 18px;
    padding: 10px 20px;
    .el-dialog__title{
        color: #fff;
    }
    
}
.dialog /deep/ .audit-reason {
    border-radius: 4px;
    border: 2px solid #409EFF;
}
.dialog /deep/  .el-dialog__headerbtn{
    top: 12px;
}
.dialog /deep/  .el-dialog__close,.el-dialog__headerbtn{
    color: #fff !important;
    // &:hover{
    //      color: #fff;
    // }
}
.dialog /deep/  .el-dialog__body,.el-dialog__footer{
    background:rgba(250,243,229,.8)
}
.dialog /deep/  .el-dialog__body{
    padding: 20px 20px 2px;
}
.dialog /deep/  .el-dialog__footer{
    padding-top: 0;
    // display: flex;
    justify-content: space-between;
    // background-color: rgba(250, 243, 229, 0.8) !important;
}
</style>